/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 17:20 19.04.2023
 * @ Description: Credit
 */


import "./index.css"
import MyButton from "../../compenent/button/MyButton";
import GamePageManager from "../../utils/GamePageManager";

export default function About() {
  return (
    <div className="GamePage About">
        <h1>About</h1>
        <p>Alors, en gros, j’suis <a href="https://fr.wikipedia.org/wiki/Dysorthographie">disorthpgraphique</a>, ce qui fait que mon orthographe est désatreuse. du coup j’ai fait ce petit jeu pour permettre au gens qui a arrète pas de me faire des remarque sur mon orthographe de ce défouler et si possible de les instruire un peux sur mon trouble.</p>
        <MyButton title={"Back"} fontSize={40} addStyle={{marginTop:"auto",marginBottom:50}} onClick={()=>GamePageManager.changePage("MainMenu")}/>
    </div>
  );
}

